export enum ChannelType {
  YOUTUBE = 'YOUTUBE',
  TWITCH = 'TWITCH',
  AFREECATV = 'AFREECATV',
  INSTAGRAM = 'INSTAGRAM',
  TICTOK = 'TICTOK',
  TWITTER = 'TWITTER',
  OTHER = 'OTHER',
  CHZZK = 'CHZZK',
}

export enum ChannelText {
  YOUTUBE = '유튜브',
  TWITCH = 'X',
  AFREECATV = 'SOOP',
  INSTAGRAM = 'INSTAGRAM',
  TICTOK = 'TICTOK',
  TWITTER = 'TWITTER',
  OTHER = 'OTHER',
  CHZZK = 'CHZZK',
}

export enum ChannelPaginateOrder {
  SUBSCRIBER = 'SUBSCRIBER',
  VIEW = 'VIEW',
  TOTAL = 'TOTAL',
}

export enum ChannelSearchRange {
  REALTIME = 'REALTIME',
  YEARLY = 'YEARLY',
  MONTHLY = 'MONTHLY',
  DAILY = 'DAILY',
}

export enum ElectionStatus {
  BEFORE_START = 'BEFORE_START',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}

export enum FilterType {
  SINGLE = 'SINGLE',
  MUTILPLE = 'MULTIPLE',
}
